import ApiError from 'util/api/errors/ApiError';

const ERROR_DETAIL_NOT_FOUND = 'PERMISSION_DENIED';
const ERROR_MESSAGE_NOT_FOUND = 'Sorry, you don\'t have permissions to perform this task.';

export default class UnauthorizedError extends ApiError {
    constructor(response) {
        super(ERROR_MESSAGE_NOT_FOUND, response, ERROR_DETAIL_NOT_FOUND);
    }
}



// WEBPACK FOOTER //
// ./src/util/api/errors/UnauthorizedError.js